/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_CUSTOMER_CATEGORIES,
  GET_CUSTOMER_CATEGORIES_SUCCESS,
  GET_CUSTOMER_CATEGORIES_ERROR,
  CLEAR_CUSTOMER_CATEGORIES,
  CLEAR_ALL_CUSTOMER_CATEGORIES_LIST,
  SEND_ADD_CUSTOMER_CATEGORIES,
  SEND_ADD_CUSTOMER_CATEGORIES_SUCCESS,
  SEND_ADD_CUSTOMER_CATEGORIES_ERROR,
  SET_VALUES_FORM_ADD_CUSTOMER_CATEGORIES,
  SEND_REMOVE_CUSTOMER_CATEGORIES,
  SEND_REMOVE_CUSTOMER_CATEGORIES_SUCCESS,
  SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR,
  SET_CUSTOMER_CATEGORIES_QUERY,
  SET_GO_TO_CATEGORY_DETAILS,
  CLEAR_GO_TO_CATEGORY_DETAILS,
  SET_SELECTED_CUSTOMER_CATEGORIES,
} from 'src/actions/customerCategoriesActions';

const goToCategoryDetails = {
  contactId: null,
  wasReturned: false,
  query: {},
};

const formAddCustomerCatetories = {
  loading: false,
  contactCategoryIds: [],
};

const initialState = {
  query: {
    sort: [['contactCategory', 'name', 'asc']],
    page: 1,
    pageSize: 50,
  },
  customerCategories: [],
  customerCategoriesCount: 0,
  allCustomerCategoriesList: [],
  selectedCustomerCategories: [],
  formAddCustomerCatetories,
  goToCategoryDetails,
  loading: false,
  allCategoriesLoading: false,
};

const customerCategoriesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CUSTOMER_CATEGORIES: {
      const isPaginationDisabled = payload;
      return produce(state, (draft) => {
        if (isPaginationDisabled) {
          draft.allCategoriesLoading = true;
        } else {
          draft.loading = true;
        }
      });
    }

    case GET_CUSTOMER_CATEGORIES_SUCCESS: {
      const { isPaginationDisabled } = payload || {};
      return produce(state, (draft) => {
        if (isPaginationDisabled) {
          draft.allCustomerCategoriesList = payload?.data || [];
        } else {
          draft.customerCategories = payload?.data || [];
          draft.customerCategoriesCount = payload?.count;
        }
        draft.loading = false;
        draft.allCategoriesLoading = false;
      });
    }

    case GET_CUSTOMER_CATEGORIES_ERROR:
    case SEND_REMOVE_CUSTOMER_CATEGORIES_SUCCESS:
    case SEND_REMOVE_CUSTOMER_CATEGORIES_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.allCategoriesLoading = false;
      });
    }

    case SEND_REMOVE_CUSTOMER_CATEGORIES: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case SEND_ADD_CUSTOMER_CATEGORIES: {
      return produce(state, (draft) => {
        draft.formAddCustomerCatetories.loading = true;
      });
    }

    case SEND_ADD_CUSTOMER_CATEGORIES_SUCCESS:
    case SEND_ADD_CUSTOMER_CATEGORIES_ERROR: {
      return produce(state, (draft) => {
        draft.formAddCustomerCatetories.loading = false;
      });
    }

    case CLEAR_CUSTOMER_CATEGORIES: {
      return produce(state, (draft) => {
        draft.customerCategories = [];
        draft.customerCategoriesCount = 0;
      });
    }

    case CLEAR_ALL_CUSTOMER_CATEGORIES_LIST: {
      return produce(state, (draft) => {
        draft.allCustomerCategoriesList = [];
      });
    }

    case SET_SELECTED_CUSTOMER_CATEGORIES: {
      return produce(state, (draft) => {
        draft.selectedCustomerCategories = payload || [];
      });
    }

    case SET_GO_TO_CATEGORY_DETAILS: {
      return produce(state, (draft) => {
        draft.goToCategoryDetails = {
          ...state.goToCategoryDetails,
          ...payload,
        };
      });
    }

    case CLEAR_GO_TO_CATEGORY_DETAILS: {
      return produce(state, (draft) => {
        draft.goToCategoryDetails = payload ? goToCategoryDetails : {
          ...state.goToCategoryDetails,
          contactId: null,
        };
      });
    }

    case SET_VALUES_FORM_ADD_CUSTOMER_CATEGORIES: {
      return produce(state, (draft) => {
        draft.formAddCustomerCatetories = payload ? {
          ...state.formAddCustomerCatetories,
          ...payload,
        } : formAddCustomerCatetories;
      });
    }

    case SET_CUSTOMER_CATEGORIES_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    default: {
      return state;
    }
  }
};

export default customerCategoriesReducer;
